// extracted by mini-css-extract-plugin
export var closeButton = "_le-2";
export var closeButtonIcon = "_le-3";
export var lightboxContent = "_le-1";
export var lightboxOverlay = "_le-0";